var Connection = require('v4-stack/connection');

/*
 * Provide a factory for creating connections with provided Aliases and
 * Transport instances
 */
module.exports.create = function(aliases, transports) {
    return new Connection(aliases, transports);
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/v4-stack/connection-factory.js
// module id = 1081
// module chunks = 1